import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function CssbuySpreadsheet() {
  return <ArticleLayout content={allArticles[5]} />;
}